import React from "react";

const VARIANT_LABELS = {
  pass: "Pass",
  warn: "Warning",
  fail: "Fail",
  info: "Info",
};

export default function StatusBadge({ variant = "info", children, title }) {
  const safeVariant = VARIANT_LABELS[variant] ? variant : "info";
  const fallbackLabel = VARIANT_LABELS[safeVariant];
  return (
    <span
      className={`verification-status-badge verification-status-badge--${safeVariant}`}
      role="status"
      aria-label={typeof children === "string" ? children : fallbackLabel}
      title={title}
    >
      {children || fallbackLabel}
    </span>
  );
}
